import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AppHeader } from "./components/AppHeader";
import { ProtectedRoute } from "./hooks/useAuth";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { NewStoryPage } from "./pages/NewStoryPage";
import { OnboardingCelebrationPage } from "./pages/OnboardingCelebrationPage";
import { OnboardingIntroPage } from "./pages/OnboardingIntroPage";
import { OnboardingPromptsPage } from "./pages/OnboardingPromptsPage";
import { ProfilePage } from "./pages/ProfilePage";
import { RegisterPage } from "./pages/RegisterPage";
import { ReRecordPage } from "./pages/ReRecordPage";
import { StoriesListPage } from "./pages/StoriesListPage";
import { StoryDetailPage } from "./pages/StoryDetailPage";
import { WelcomePage } from "./pages/WelcomePage";
import "./index.css";

function AuthenticatedLayout() {
	return (
		<ProtectedRoute>
			<AppHeader />
			<Outlet />
		</ProtectedRoute>
	);
}

function OnboardingLayout() {
	return (
		<ProtectedRoute>
			<Outlet />
		</ProtectedRoute>
	);
}

function Footer() {
	const { pathname } = useLocation();
	if (pathname === "/welcome") return null;
	return (
		<footer className="py-8 text-center">
			<p className="font-ui text-[10px] uppercase tracking-widest text-ink/25">
				Wild Yeast Labs
			</p>
		</footer>
	);
}

export function App() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Navigate to="/onboarding" replace />} />

				{/* Public routes */}
				<Route path="/welcome" element={<WelcomePage />} />
				<Route path="/onboarding" element={<OnboardingIntroPage />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/register" element={<RegisterPage />} />

				{/* Protected onboarding routes (no AppHeader) */}
				<Route element={<OnboardingLayout />}>
					<Route
						path="/onboarding/prompts"
						element={<OnboardingPromptsPage />}
					/>
					<Route
						path="/onboarding/celebration"
						element={<OnboardingCelebrationPage />}
					/>
				</Route>

				{/* Protected app routes (with AppHeader) */}
				<Route element={<AuthenticatedLayout />}>
					<Route path="/home" element={<HomePage />} />
					<Route path="/stories" element={<StoriesListPage />} />
					<Route path="/stories/new" element={<NewStoryPage />} />
					<Route path="/stories/:id" element={<StoryDetailPage />} />
					<Route path="/stories/:id/rerecord" element={<ReRecordPage />} />
					<Route path="/profile" element={<ProfilePage />} />
				</Route>
			</Routes>
			<Footer />
		</>
	);
}

export default App;
